import axios from 'axios';

// Get all technicians
export const getTechnicians = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.search) queryString += `search=${encodeURIComponent(filters.search)}&`;
    if (filters.type) queryString += `type=${filters.type}&`;
    if (filters.include_inactive) queryString += `include_inactive=${filters.include_inactive}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/technicians${queryString ? '?' + queryString : ''}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching technicians' };
  }
};

// Get technician by ID
export const getTechnicianById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/technicians/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching technician details' };
  }
};

// Create new technician
export const createTechnician = async (technicianData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/technicians', technicianData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating technician' };
  }
};

// Update technician
export const updateTechnician = async (id, technicianData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/technicians/${id}`, technicianData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating technician' };
  }
};

// Delete technician (soft delete)
export const deleteTechnician = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/technicians/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting technician' };
  }
};
